import './theme.css'
import { Theme } from '@radix-ui/themes'
import cn from 'clsx'

import React from 'react'
export type ThemeContextType = {
  theme: 'light' | 'dark' | null
}
export const ThemeContext: React.Context<ThemeContextType> =
  React.createContext<ThemeContextType>({
    theme: null,
  })
type Props = {
  children: React.ReactNode
  value: ThemeContextType
}
export const ThemeProvider = ({ children, value }: Props): React.ReactNode => (
  <Theme
    appearance={value.theme === 'dark' ? 'dark' : 'light'}
    hasBackground={false}
  >
    <ThemeContext.Provider value={value}>
      <div
        className={cn({
          'theme--default': !value.theme,
          'theme--light': value.theme === 'light',
          'theme--dark': value.theme === 'dark',
        })}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  </Theme>
)
